// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZSCp","label":"styles_label__3nqSe"};